<template>
    <div :class="['footer', 'pc-visible', href.indexOf('/main') > -1 ? 'main_footer' : '']">
        <div class="footer_inner">
            <p>(06090)서울특별시 강남구 학동로 426 (삼성동) 02-3423-5114 (120 다산콜센터로 연결)  02-3423-6000~3 (당직실 / 야간·공휴일) </p>
            <p>FAX. 02-3423-8800  COPYRIGHT 2021. GANGNAM-GU OFFICE, ALL RIGHTS RESERVED.</p>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            href: window.location.href,
        }
    },
    components: {
    },
}
</script>
